import React from 'react'
import { Bar } from 'react-chartjs-2'
import I18n from 'i18n'
import {
  chartjsDefaultOptions,
  chartjsTitleProperties
} from '../../../../common/Constants'
import { round } from '../../../../common/Math'

const barLabelsPlugin = {
  id: 'weeklyInjuriesBarLabels',
  afterDatasetsDraw: (chart) => {
    const ctx = chart.ctx
    ctx.save()
    ctx.font = '12px \'Helvetica Neue\', \'Helvetica\', \'Arial\', sans-serif'

    const meta = chart.getDatasetMeta(0)
    meta.data.forEach(function (bar, index) {
      const label = chart.data.labels[index]
      const xOffset = 20
      const yOffset = bar.y + 4
      ctx.shadowColor = 'white'
      ctx.shadowBlur = 10
      ctx.fillStyle = 'black'
      ctx.fillText(label, xOffset, yOffset)
      ctx.shadowBlur = 0
    })
    ctx.restore()
  }
}

const WeeklyInjuries = (props) => {
  if (!props.sundaySummary || props.sundaySummary.length === 0) {
    return <></>
  }

  const params = ['participation', 'symptoms_complaints', 'affected_performance', 'reduced_training']
  const colors = ['#1492BB', '#0A720A', '#BE1111', '#FF7B00']
  const datasets = []

  datasets.push({
    label: I18n.t('components.dashboards.questionnaire.weekly.injuries.severity_score'),
    backgroundColor: colors,
    data: params.map(cParam => round(props.sundaySummary[0][cParam] * 100, 0))
  })
  const options = {
    ...chartjsDefaultOptions,
    indexAxis: 'y',
    plugins: {
      title: {
        text: I18n.t('components.dashboards.questionnaire.weekly.injuries.title'),
        ...chartjsTitleProperties
      },
      tooltip: {
        mode: 'index',
        intersect: false
      },
      legend: {
        display: false
      }
    },
    scales: {
      y: {
        ticks: {
          display: false
        },
        grid: {
          display: false
        }
      },
      x: {
        suggestedMin: 0,
        suggestedMax: 100,
        title: {
          display: true,
          text: I18n.t('components.dashboards.questionnaire.weekly.injuries.severity_score')
        }
      }
    }
  }

  const data = {
    labels: params.map(param => I18n.t(`components.dashboards.questionnaire.weekly.injuries.params.${param}`)),
    datasets: datasets
  }
  return (
    <div className='questionnaire-chartjs-container barchart'>
      <Bar height={300} data={data} options={options} plugins={[barLabelsPlugin]} redraw />
    </div>
  )
}

export default WeeklyInjuries
